// extracted by mini-css-extract-plugin
module.exports = {"loginPage":"Login_loginPage__vXrJ6"};